export const STAGE0 = {
  LABELS: {
    FARM: 'Select Farm',
    HARVEST_YEAR: 'Harvest year',
    PRODUCT_NAME: 'Product Name',
    CROP_TYPE: 'Select Crop Type',
    FIELD_AREA: 'Field Area',
    UNIT: 'Unit',
    FARM_REVENUE: '% of farm revenue covered',
    DRY_WEIGHT: 'Total Crop Weight (dry) (kg)',
    WET_WEIGHT: 'Total Crop Weight (wet) (kg)',
    COMMODITY_DESCRIPTION: 'Commodity Description',
    CO_PRODUCT_NAME: "Co-product Type",
    ALLOCATION: 'Economic allocation (%)',
    FARM_TITLE: "Farm",
    CROP_TYPE_NAME: "Crop type",
    CO_PRODUCTS: "Co-products",
    DRY_WEIGHT_UNIT: " kgCO2e",
    DRY_WEGHT_TITLE: 'Total crop weight (Dry)',
    COMMODITY_NAME: 'Commodity Name',
    REPORTING_YEAR: 'Reporting year',
    ALLOCATION_LABEL: '% of Farm revenue',
    COMMODITY_YEAR: "Commodity Year",
    TOTAL_BEEF_WEIGHT: "Total Beef weight (kg)"
  },
  FIELD_NAMES: {
    FARM_NAME: 'locationId',
    HARVEST_YEAR_NAME: 'harvestYear',
    PRODUCT_NAME_NAME: 'name',
    CROP_TYPE_NAME: 'cropId',
    FIELD_AREA_NAME: 'area',
    UNIT_NAME: 'areaUnit',
    FARM_REVENUE_NAME: 'revenuePercentage',
    DRY_WEIGHT_NAME: 'dryWeight',
    WET_WEIGHT_NAME: 'wetWeight',
    COMMODITY_DESCRIPTION_NAME: 'description',
    CO_PRODUCTS: "coProducts",
    ALLOCATION_NAME: "allocation",
    REPORTING_YEAR_NAME: 'year',
  },
};

export const stage0UnitMeta = [
  { label: 'ha', value: 'hectare' },
  { label: 'm2', value: 'square meter' },
  { label: 'Acres', value: 'acre' },
];

export const META_QUERY = "commodity"
export const FORM_TITLE = "Create Farm Commodity"
export const META_TYPE = 'farm_ingredient'
export const FEED_META_TYPE = 'feed'
export const UPDATE_FORM_TITLE = "Update Farm Commodity"
export const FARM_TITLE = "Farm Commodity"
export const LIVE_STOCK_TITLE = {
  BEEF_COMMODITY: 'Beef Commodity',
  DAIRY_COMMODITY: 'Create Dairy Commodity',
  POULTRY_COMMODITY: 'Create Poultry Commodity',
  PORK_COMMODITY: 'Create Pork Commodity',
  UPDATE_BEEF_COMMODITY: 'Update Beef Commodity',
  CREATE_BEEF_COMMODITY: 'Create Beef Commodity',
}
export const stagesHeaderConstants = {
  CANCEL_MODEL: {
    CLOSE: 'Close anyway',
    SAVE: 'Save & Proceed',
    DESCRIPTION: 'Do you want to close the current page without saving?'
  },
  COMMODITY_INFO: 'Commodity info'
}

export const actionButtons = {
  ADD_FERTILISER: 'Add Fertiliser',
  ADD_PACKAGING_MATERIAL: 'Add Packaging Material',
  NEXT: 'Next',
  ADD_END_MORKET_LOCATION: 'Add End Market Location',
  TOTAL: "Total",
}

export const farmStagesTitles = {
  RAW_MATERIALS: '1. Raw Materials',
  TRANSPORTATION: '2. Raw Materials Transportation',
  FUEL_AND_ENERGY: '3. Fuel and energy',
  FIELD: '4. Field',
  PRODUCT_OVERVIEW: '5. Commodity Distribution',
};

export const notificationConstants = {
  SUCCESS: {
    TITLE: 'Commodity Created Successfully',
    MANURE_MANAGEMENT: "Manure Management Updated Successfully",
    UPDATE_TITLE: 'Commodity Updated Successfully',
    FEED_UPDATE: "Feed Updated Successfully"
  }
};

export const CommodityTypes = {
  LIVE_STOCK: "livestock",
  AGRICULTURE: "agriculture"
}

